// Phase 4 Wave 0 — Stimulus controllers auto-registration.
//
// esbuild-rails plugin (see esbuild.config.mjs) expands the glob below at build time;
// every `*_controller.js` in this directory (and subdirectories) is auto-imported and
// registered. Subsequent plans MUST add new controllers by dropping `<name>_controller.js`
// into this directory — DO NOT add manual `application.register(...)` lines here.
//
// LOCK (plan 04-02 Task 1): no other plan edits this file.

import { application } from "./application"
import controllers from "./**/*_controller.js"

controllers.forEach((controller) => {
  application.register(controller.name, controller.module.default)
})
